import {forwardRef} from 'react';
import clsx from 'clsx';
import type {SvgIconProps, IconSize} from './svg-icon';

const sizeTokens: Record<string, number> = {
  '2xs': 12,
  xs: 14,
  sm: 16,   // ↓ smaller than before
  md: 18,   // ↓ default will be md=18px (used to be 20)
  lg: 20,
  xl: 24,
};
function resolveSize(size?: IconSize): number|string {
  if (size == null) return '1em';
  if (typeof size === 'number') return size;
  if (/^\d+(\.\d+)?(px|em|rem|%)?$/.test(size)) return size;
  return sizeTokens[size] ?? '1em';
}

export function withMuiAdapter(Base: any, displayName?: string) {
  const Icon = forwardRef<SVGSVGElement, SvgIconProps>(function Icon(props, ref) {
    const {size='md', color, className, title, 'aria-label': ariaLabel, style, ...rest} = props as any;
    const dim = resolveSize(size);
    return (
      <Base
        ref={ref as any}
        className={clsx('svg-icon', 'svg-icon--mui', className)}
        htmlColor={color}
        sx={{ fontSize: dim }}
        style={{ stroke: 'none', ...style }}           
        focusable={false}
        aria-label={ariaLabel || title || displayName}
        role={ariaLabel || title ? 'img' : undefined}
        {...rest}
      />
    );
  });
  Icon.displayName = `${displayName || 'Icon'}(mui)`;
  return Icon;
}
